import { MdLock } from '@dsx/react';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import logoSvg from '../../assets/images/tels-navbar-logo.svg';
import type { MenuLink } from '../TopNav';
import { TopNav } from '../TopNav';
import { topNavData, topNavServiceProviderData } from '../TopNav/topNavData';

const MenuVariantPaths = {
	CONNECT: '/connect',
	SERVICE_PROVIDER: '/service-provider',
};

const registerLink =
	'https://smart.tels.net/SMART/ServiceProviderPortal/Registration?utm_source=sign-up-top&utm_medium=landing-page&utm_campaign=rsa';

const isPathMatch = (pathName: string, value: string) => {
	return pathName.startsWith(value);
};

const getCtaLinks = (pathname: string): MenuLink[] => {
	if (isPathMatch(pathname, MenuVariantPaths.CONNECT)) {
		return [
			{
				path: 'register',
				label: 'Register',
				value: registerLink,
				openInNewTab: true,
			},
			{
				path: 'sign-in',
				label: 'Sign in',
				value: 'https://smart.tels.net/SMART/ServiceProviderPortal',
				openInNewTab: true,
				icon: MdLock,
			},
		];
	}

	return [
		{
			path: 'contact/',
			label: 'Contact us',
			value: 'contact/',
			openInNewTab: false,
		},
		{
			path: 'sign-in',
			label: 'Sign in',
			value: isPathMatch(pathname, MenuVariantPaths.SERVICE_PROVIDER)
				? 'https://smart.tels.net/SMART/ServiceProviderPortal'
				: 'https://www.tels.net/TELSLogin/signin.aspx',
			openInNewTab: true,
			icon: MdLock,
		},
	];
};

const TopNavTels = () => {
	const logo = {
		svg: logoSvg,
		alt: 'DS TELS Logo',
		href: '/',
		width: '227px',
		height: '36px',
	};

	const { pathname } = useLocation();
	const ctaLinks = getCtaLinks(pathname);

	// TODO: allow for trailing slash in path
	const primaryContent = useMemo(() => {
		if (isPathMatch(pathname, MenuVariantPaths.CONNECT)) {
			return [];
		}

		if (isPathMatch(pathname, MenuVariantPaths.SERVICE_PROVIDER)) {
			return topNavServiceProviderData;
		}

		return topNavData;
	}, [pathname]);

	return (
		<TopNav
			activePath={pathname}
			menuContent={primaryContent}
			ctaLinks={ctaLinks}
			logo={logo}
		/>
	);
};

export { TopNavTels };
